import React from "react";

// Date separator between message-day groups (design C2): a centered, quiet gray
// pill reading "Tuesday, 7 Jul". Stream's MessageList renders this between days
// (it passes a `date` prop — a Date or a parseable value). Built manually so the
// order stays "weekday, D Mon" regardless of the en-US locale default.
const ChatDateSeparator = ({ date }) => {
  if (!date) return null;
  const d = date instanceof Date ? date : new Date(date);
  if (Number.isNaN(d.getTime())) return null;

  const weekday = d.toLocaleDateString("en-US", { weekday: "long" });
  const mon = d.toLocaleDateString("en-US", { month: "short" });
  const label = `${weekday}, ${d.getDate()} ${mon}`;

  return (
    <div className="flex justify-center my-3">
      <span className="px-3 py-1 rounded-full bg-[#F2F4F7] text-[#475467] text-[11px] font-medium">
        {label}
      </span>
    </div>
  );
};

export default ChatDateSeparator;
